import { LocalizedText, LocalizedTextProps } from '@mews/framework';
import { TooltippedTag, TooltippedTagProps } from '../tooltip';

export const LocalizedTextTag: React.FC<TooltippedTagProps & Pick<LocalizedTextProps, 'textKey'>> = ({
    textKey,
    variant,
    ...other
}) => (
    <TooltippedTag variant={variant} {...other}>
        <LocalizedText textKey={textKey} />
    </TooltippedTag>
);
